<template>
	<v-chip :class="buttonClass">
		
		
		<v-icon class="icn">
			<slot name="icon">
				<coin-icon></coin-icon>
			</slot>
		</v-icon>


		<span v-if="coins_amount !== undefined && coins_amount !== null" class="d-flex align-center">
			<template v-if="showBoost && coinBoost.hasActiveBoost">
				<span class="coin-chip__amount ml-1 text-decoration-line-through mr-1">+{{ abbreviateNumber(coinBoost.originalCoins) }}</span>
				<span class="coin-chip__amount coin-chip__amount--boosted">↑{{ abbreviateNumber(coinBoost.boostedCoins) }}</span>
				<v-tooltip activator="parent" location="top">
					<span>{{ boostTooltipText }}</span>
				</v-tooltip>
			</template>
			<span v-else class="coin-chip__amount ml-1">
				+{{ abbreviateNumber(coins_amount) }}
			</span>
		</span>


		<span v-else class="coin-chip__amount d-flex align-center">
			<slot name="amount"></slot>
		</span>


	</v-chip>
</template>



<script setup>

import CoinIcon from "@/icons/Coin.vue";
import { computed } from 'vue';
import { calculateBoostedCoins } from '@/utils/coinBoostCalculator';
import { abbreviateNumber } from '@/utils/GlobalMethods';

const props = defineProps({
	coins_amount: Number,
	status: {
		type: String,
		default: 'normal',
		validator: (value) => ['normal', 'primary', 'cut'].includes(value),
	},
	showBoost: {
		type: Boolean,
		default: false
	}
});

const buttonClass = computed(() => {
	if (props.status === 'normal') return '';
	if (props.status === 'primary') return 'button--primary';
	if (props.status === 'cut') return 'cut-button';
	return '';
});

const coinBoost = computed(() => {
	if (!props.showBoost) return { hasActiveBoost: false, originalCoins: props.coins_amount, boostedCoins: props.coins_amount };
	return calculateBoostedCoins(props.coins_amount);
});

const boostTooltipText = computed(() => {
	if (!coinBoost.value.hasActiveBoost) return '';
	
	if (coinBoost.value.boostPercentage) {
		return `${coinBoost.value.boostPercentage}% coin boost active`;
	}
	
	const extraCoins = coinBoost.value.boostedCoins - coinBoost.value.originalCoins;
	return `+${extraCoins} coins boost active`;
});

</script>

<style scoped>
.coin-chip__amount--boosted {
	color: #F83587;
	font-weight: bold;
}
</style>